document.addEventListener("DOMContentLoaded", function () {
    const dropdownButton = document.getElementById("dropdownButtonlifetime");
    const dropdownMenu = document.getElementById("dropdownMenulifetime");
    const buttonCol2Container = document.querySelector(".buton-two");
    const buttonCol2 = document.querySelector(".btn.btn-outline-primary.btn-two");

    let selectedURL = null;
    let currentSelectedItem = null;

    buttonCol2Container.style.display = "none";

    dropdownButton.addEventListener("click", function (event) {
        event.stopPropagation();
        dropdownMenu.classList.toggle("show");
        dropdownButton.classList.toggle("active");
    });

    document.addEventListener("click", function () {
        dropdownMenu.classList.remove("show");
        dropdownButton.classList.remove("active");
    });

    dropdownMenu.querySelectorAll("a").forEach(function (item) {
        item.addEventListener("click", function (event) {
            event.preventDefault();
            const selectedText = item.textContent.trim();

            if (selectedText === "Please Select") {
                const icon = dropdownButton.querySelector(".icon-triangle");
                dropdownButton.innerHTML = `${selectedText}`;
                if (icon) {
                    dropdownButton.appendChild(icon);
                }

                buttonCol2Container.style.display = "none";

                dropdownMenu.classList.remove("show");
                dropdownButton.classList.remove("active");

                if (currentSelectedItem) {
                    currentSelectedItem.classList.remove("selected-item");
                }
                currentSelectedItem = null;
                return;
            }

            selectedURL = item.dataset.href;

            const icon = dropdownButton.querySelector(".icon-triangle");
            dropdownButton.textContent = selectedText;
            if (icon) {
                dropdownButton.appendChild(icon);
            }

            buttonCol2Container.style.display = "block";

            dropdownMenu.classList.remove("show");
            dropdownButton.classList.remove("active");

            if (currentSelectedItem) {
                currentSelectedItem.classList.remove("selected-item");
            }
            item.classList.add("selected-item");
            currentSelectedItem = item;

            event.stopPropagation();
        });
    });

    buttonCol2.addEventListener("click", function () {
        if (selectedURL) {
            window.open(selectedURL, "_blank");
            selectedURL = null;

            if (currentSelectedItem) {
                currentSelectedItem.classList.remove("selected-item");
                currentSelectedItem = null;
            }
        }
    });
});
